module.exports = __webpack_public_path__ + "static/media/remove_from_waitlist.b12118ac.svg";